@import '../../scss/mixin';

.history {
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 16px 20px 16px;
  gap: 12px;
  padding: 16px;
  cursor: pointer;
  background: #F2EFEB;
  box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.0);
  transition: box-shadow ease-in-out 350ms;
  user-select: none;

  &:hover {
    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.35);
  }
}

.head {
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #28292b66;
}

.content {
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding-right: 32px;
}

.user {
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: -0.24px;
  color: #28292B;
}

.foot {
  display: flex;
  align-items: flex-end;
  width: 100%;
}

.assistant {
  flex-grow: 1;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: 0.36px;
  color: #3E3F41;
}

.delete {
  @include btn();
  width: 24px;
  height: 24px;
  aspect-ratio: 1/1;
}